import { gql } from "@apollo/client";

export const TrailResultQuery = gql`
  query GetAllTrialResult($pageNumber: Int!, $pageSize: Int!) {
    getAllTrialResult(pageNumber: $pageNumber, pageSize: $pageSize) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        date
        search
        handler
        dog
        breed
        div
        qNq
        ngReason
        time
        hidesFound
        faults
        faultReason
        points
        place
        timeLimit
        hidesSet
        judgeNotes
        searchName
        trialCalendarId
      }
    }
  }
`;

export const TrailResultDetailsQuery = gql`
  query GetTrialResultByTrialCalendar(
    $id: String!
    $pageNumber: Int!
    $pageSize: Int!
    $sortOrder: String
    $qNq: String
  ) {
    getTrialResultByTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      trialCalendarId: $id
      sortOrder: $sortOrder
      qNq: $qNq
    ) {
      pageSize
      totalDocs
      totalPages
      totalCount
      pageNumber
      data {
        id
        date
        search
        handler
        dog
        breed
        div
        qNq
        ngReason
        time
        hidesFound
        faults
        faultReason
        points
        place
        timeLimit
        hidesSet
        judgeNotes
        searchName
        trialCalendarId
      }
    }
  }
`;

export const getAllTrialResultUniqueElementsQuery = gql`
  query GetAllTrialResultUniqueElements($trialCalendarId: Int!) {
    getAllTrialResultUniqueElements(trialResultId: $trialCalendarId)
  }
`;

export const getAllAwardsQuery = gql`
  query GetAllAwards($trialCalendarId: Int!) {
    getAllAwards(trialCalendarId: $trialCalendarId) {
      id
      date
      search
      handler
      dog
      registration_name
      dogImage
      breed
      trialCalendarId
      award
    }
  }
`;

export const getTrialCalendarByIdQuery = gql`
  query GetTrialCalendarById($trialCalendarId: Int!) {
    getTrialCalendarById(trialCalendarId: $trialCalendarId) {
      id
      authId
      judgeName
      hostName
      host {
        id
        hostName
        contactAddress
        city
        trialSecretaryName
        state
        trialSecretaryEmail
        zip
        phoneNumber
      }
      trail {
        id
        trialName
        trialLocationName
        trialLocationAddress
        city
        state
        zip
        timezone
        trialDate
        openDate
        closeDate
        cutoffDate
        trialFile
        description
        notes
        noOfJudge
        judgeAuthId
        trialFees
        maxEntries
        trialImages
        status
        approvalStatus
      }
      searches {
        entryFee
        id
        level
        element
        searchName
      }
      sharedUsers {
        name
        email
        authId
      }
    }
  }
`;

export const getTrialResultByInElementOrderQuery = gql`
  query GetTrialResultByInElementOrder(
    $trialCalendarId: Int!
    $searchName: String
  ) {
    getTrialResultByInElementOrder(
      trialCalendarId: $trialCalendarId
      searchName: $searchName
    ) {
      searchName
      results {
        id
        date
        search
        handler
        dog
        breed
        div
        qNq
        ngReason
        time
        hidesFound
        faults
        faultReason
        points
        place
        timeLimit
        hidesSet
        judgeNotes
        searchName
        trialCalendarId
      }
    }
  }
`;

export const UpdateTrailResultDetailsMutation = gql`
  mutation UpdateTrialResult($id: Int!, $data: UpdateTrialResultInput!) {
    updateTrialResult(trialResultId: $id, data: $data) {
      message
    }
  }
`;
